

















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as APITypes from '@/controllers/api/types';
import * as Global from '@/global';
import * as Error from '@/utils/errors';
import API from '@/controllers/api';
import Ratings from '@/components/RatingsPanel/index.vue';
import Commit from '@/components/Commit/index.vue';

@Component({ components: { Ratings, Commit } })
export default class RepoPreview extends Vue {
  private isFetching: boolean = false;
  private repository: APITypes.ExtendedRepository | null = null;
  private contributors: APITypes.User[] = [];
  private commits: APITypes.Commit[] = [];
  private commitsPage: number = 1;
  private commitsPerPage: number = 10;
  private commitsFetching: boolean = false;
  private contributorsPage: number = 1;
  private contributorsPerPage: number = 10;
  private contributorsFetching: boolean = false;
  private error: Global.AppError | null = null;

  private get owner(): string {
    return this.$route.params.owner;
  }

  private get name(): string {
    return this.$route.params.name;
  }

  private get commitsEnd(): boolean {
    return this.commits.length < this.commitsPerPage;
  }

  private get contributorsEnd(): boolean {
    return this.contributors.length < this.contributorsPerPage;
  }

  private async loadRepository(): Promise<void> {
    try {
      this.repository = await API.getRepository(this.owner, this.name);
    } catch (error) {
      if (error?.status === 404) this.error = Error.NotFound('User');
      else if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    }
  }

  private async loadContributors(): Promise<void> {
    try {
      this.contributorsFetching = true;
      this.contributors = await API.getRepositoryContributors(
        this.owner,
        this.name,
        { page: this.contributorsPage, perPage: this.contributorsPerPage }
      );
    } catch (error) {
      if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    } finally {
      this.contributorsFetching = false;
    }
  }

  private async loadCommits(): Promise<void> {
    try {
      this.commitsFetching = true;
      this.commits = await API.getRepositoryCommits(this.owner, this.name, {
        perPage: this.commitsPerPage,
        page: this.commitsPage,
      });
    } catch (error) {
      if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    } finally {
      this.commitsFetching = false;
    }
  }

  @Watch('commitsPage')
  private async handleCommitsPageChange(): Promise<void> {
    await this.loadCommits();
  }

  @Watch('contributorsPage')
  private async handleContributorsPageChange(): Promise<void> {
    await this.loadContributors();
  }

  async mounted(): Promise<void> {
    this.isFetching = true;
    await this.loadRepository();
    await this.loadContributors();
    await this.loadCommits();
    this.isFetching = false;
  }
}
